var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline / Video, Audio, Sound / Repeat"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.645 5.14515C18.2552 4.53495 19.2445 4.53495 19.8547 5.14515L24.0214 9.31181C24.4682 9.75868 24.6019 10.4307 24.3601 11.0146C24.1182 11.5985 23.5485 11.9792 22.9165 11.9792H18.7498C11.5586 11.9792 5.729 17.8088 5.729 25C5.729 32.1911 11.5591 38.0208 18.7504 38.0208H19.7915C20.6544 38.0208 21.354 38.7204 21.354 39.5833C21.354 40.4463 20.6544 41.1458 19.7915 41.1458H18.7504C9.8334 41.1458 2.604 33.9172 2.604 25C2.604 16.0829 9.83274 8.85417 18.7498 8.85417H19.1443L17.645 7.35485C17.0348 6.74466 17.0348 5.75534 17.645 5.14515ZM28.6457 10.4167C28.6457 9.55372 29.3452 8.85417 30.2082 8.85417H31.2498C40.1669 8.85417 47.3957 16.0829 47.3957 25C47.3957 33.9171 40.1669 41.1458 31.2498 41.1458H30.8554L32.3547 42.6451C32.9649 43.2553 32.9649 44.2447 32.3547 44.8549C31.7445 45.465 30.7552 45.465 30.145 44.8549L25.9783 40.6882C25.5314 40.2413 25.3978 39.5693 25.6396 38.9854C25.8815 38.4015 26.4512 38.0208 27.0832 38.0208H31.2498C38.441 38.0208 44.2707 32.1912 44.2707 25C44.2707 17.8088 38.441 11.9792 31.2498 11.9792H30.2082C29.3452 11.9792 28.6457 11.2796 28.6457 10.4167Z",
    fill: "#28255F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/repeat.e48d94c6785c93a7325a3fbd6166f4b2.svg";
export { ForwardRef as ReactComponent };